import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Container from "react-bootstrap/Container";
import InvoiceForm from "./components/InvoiceForm";
import NavBar from "./components/NavBar"
import Footer from "./components/Footer"

const App = () => {
  return (
    <div>
      <div className="App d-flex flex-column align-items-center justify-content-center w-100">
        <Container>
          <NavBar />
          <InvoiceForm />
        </Container>
        <Footer />
      </div>
      
    </div>
  );
};
export default App;